export const ON_GLOBAL_DOWNLOAD_PROGRESS = Symbol('ON_GLOBAL_DOWNLOAD_PROGRESS')
export const ABORT_CONTROLLER = Symbol('ABORT_CONTROLLER')
